import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../api/api";

export const getFirstCompany = createAsyncThunk("product/getFirstCompany", async (_, { rejectWithValue, fulfillWithValue }) => {
  try {
    const { data } = await api.get("/home/company-get-first");
    if (process.env.NODE_ENV === "development") console.log("dataCompany", data);
    return fulfillWithValue(data);
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

export const getNavMenus = createAsyncThunk("init/getNavMenus", async (_, { rejectWithValue, fulfillWithValue }) => {
  try {
    const { data } = await api.get("/nav-menus-public");
    return fulfillWithValue(data);
  } catch (error) {
    return rejectWithValue(error.response?.data);
  }
});

export const initReducer = createSlice({
  name: "init",
  initialState: {
    currentCompany: null,
    navMenus: [],
    loading: false,
    error: null,
  },
  reducers: {
    messageClear: (state, _) => {
      state.errorMessage = "";
      state.successMessage = "";
    },
  },
  extraReducers: builder => {
    builder
      .addCase(getFirstCompany.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getFirstCompany.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.currentCompany = payload.company;
      })
      .addCase(getFirstCompany.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload;
      })
      .addCase(getNavMenus.fulfilled, (state, { payload }) => {
        state.navMenus = payload.menus;
      });
  },
});
export const { messageClear } = initReducer.actions;
export default initReducer.reducer;
